import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/indienenVoortgangsrapport/";

const IndienenVoortgangsrapportApi = {
	get(voortgangsrapportId) {
		const serviceUrl = prependRoot(routePrefix + voortgangsrapportId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	confirm(voortgangsrapportId) {
		const serviceUrl = prependRoot(routePrefix + "confirm/" + voortgangsrapportId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},

	generatePdf(voortgangsrapportId) {
		const serviceUrl = prependRoot(routePrefix + "pdf/" + voortgangsrapportId, getApiRoot());
		let returnValue = axios.post(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	}
};

export default IndienenVoortgangsrapportApi;